<template>
  <div></div>
</template>
<script setup lang="ts">
import { onMounted } from "vue";
import { useCartStore } from "@/stores/cart";
const cartStore = useCartStore();

const paramsString = window.location.search;
const searchParams = new URLSearchParams(paramsString);
const buyerToken = searchParams.get("buyerToken");

// Where every dead-ended storefront route lands, mirroring
// LineController::FALLBACK_PATH.
const FALLBACK_PATH = "/shop";

onMounted(async () => {
  if (!buyerToken) return;

  try {
    await cartStore.ordersPaymentAmazonPayGetBuyerInfo(buyerToken);
  } catch {
    // Swallowed on purpose, and caught rather than left to a bare finally so
    // the rejection does not escape this async onMounted. Nothing reads
    // cartStore.amazonBuyerData - the LP gets its Amazon context server-side
    // from UrlsController - so a failure here costs the customer nothing.
  } finally {
    // The redirect has to happen either way. GetBuyerService returns nil on a
    // 200 when it fails, so this await used to hang forever and now rejects -
    // either way the customer was left on a blank callback page with their
    // purchase ended.
    //
    // currentBaseUrl lives only in localStorage, so it is "" on a browser that
    // never loaded an LP, after an eviction, or after $reset(). "/lp?u=" makes
    // UrlsController#fetch_url raise RecordNotFound and render 404.html, which
    // ends the purchase just as surely. Both sibling callbacks guard the same
    // value the same way.
    window.location.href = cartStore.currentBaseUrl
      ? `/lp?u=${encodeURIComponent(cartStore.currentBaseUrl)}`
      : FALLBACK_PATH;
  }
});
</script>
